export default "__VITE_ASSET__C35eb_1$__"